<template>
  <section>
    <div id="meet"></div>
  </section>
</template>

<script>
export default {
  name: "Livestream",
  data() {
    return {};
  },
  mounted() {
    const domain = "meet.jit.si";
    const options = {
      roomName: "JitsiMeetAPIExample",
      width: 700,
      height: 700,
      parentNode: document.querySelector("#meet"),
      lang: "en",
    };
    const api = new JitsiMeetExternalAPI(domain, options);
  },
};
</script>